import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { QIMA_EMAIL_REGEXP } from '@qima/ngx-qima';
import { isEmpty } from 'lodash/index';

export class EmailsValidators {
  public static emails: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const { value } = control;

    if (value == null || value === '') {
      return null;
    }

    let invalidEmails: string[];

    if (typeof value === 'string') {
      invalidEmails = EmailsValidators._invalidTokensFromDelimitedString(value);
    } else if (Array.isArray(value)) {
      invalidEmails = value.filter((email: Readonly<string>): boolean => !QIMA_EMAIL_REGEXP.test(email));
    } else {
      return null;
    }

    if (isEmpty(invalidEmails)) {
      return null;
    }

    return { email: invalidEmails };
  };

  private static _invalidTokensFromDelimitedString(raw: string): string[] {
    const tokens = raw
      .replace(/[,|;]/g, ' ')
      .trim()
      .split(' ')
      .filter((t: string): boolean => t.length > 0);

    return tokens.filter((e: string): boolean => !QIMA_EMAIL_REGEXP.test(e));
  }
}
